import { Schema } from 'effect';

export const AttributeCode = Schema.String;

export type AttributeCode = Schema.Schema.Type<typeof AttributeCode>;
